var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":""},on:{"click":_vm.showReviewModal}},[_vm._v(" Review ")])
}
var staticRenderFns = []

export { render, staticRenderFns }